import styled from 'styled-components'

import bgFooter from '../../images/bg-footer.svg'
import media from '../../util/media'

export const FooterWrapper = styled.footer`
  position: relative;
  width: 100%;
  background-image: url(${bgFooter});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  padding: 100px 0 60px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  ${media.lessThan('md')`
    text-align: center;
    padding: 60px 0 30px;
  `}
`

export const FooterLink = styled.a`
  color: ${({ theme }) => theme.colors.light};
  font-weight: 700;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  ${media.lessThan('md')`
    margin-top: 6px;
    display: inline-block;
  `}
`

export const FooterBreak = styled.br`
  display: block;

  ${media.greaterThan('sm')`
    display: none;
  `}
`
